import { apiClientV2 } from '@/services/rest-api-webhook/apiClient'
const baseURL = process.env.VUE_APP_REST_API_WEBHOOK
const baseEndpoint = '/targets'

export const get = async (queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    search: queryParam?.search || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: baseEndpoint,
    params: params,
  })

  return response?.data
}

export const getDetail = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: baseEndpoint + '/' + id,
  })

  return response?.data
}

export const store = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: baseEndpoint,
    data: data,
  })

  return response?.data
}

export const patch = async (id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PATCH',
    url: baseEndpoint + '/' + id,
    data: data,
  })

  return response?.data
}

export const remove = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'DELETE',
    url: baseEndpoint + '/' + id,
  })

  return response?.data
}